
import FailPayment from '~/pages/_lang/payment/fail/index.vue'
export default FailPayment
